import React from "react";
import { Box } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import CorporateSignature from "my-tax/components/corporate-signature";
import useStyles from "my-tax/components/family-tax-credit-application-print/family-tax-credit-application-print.style";
import { DOTTED_LINE } from "my-tax/constants";
import { ocLightTheme } from "oc/themes/oc-light-theme";
import formatTaxNumber from "oc/utils/format-tax-number";

interface MyTaxCreditApplicationPrintEmployerProps {
  employerName: string | null | undefined;
  employerTaxNumber: string | null | undefined;
}

export const MyTaxCreditApplicationPrintEmployer = ({
  employerName,
  employerTaxNumber,
}: MyTaxCreditApplicationPrintEmployerProps) => {
  const classes = useStyles();

  return (
    <ThemeProvider theme={ocLightTheme}>
      <Box className={classes.blackBorder}>
        <Box>
          <Box display="flex">
            <Box
              style={{
                fontWeight: "bold",
                marginRight: "8px",
              }}
            >
              II.
            </Box>
            <Box>
              Az I. Blokkban szereplő magánszemély munkáltatója/ kifizetője
            </Box>
          </Box>
        </Box>
        <Box height="10px" />
        <Box display="flex">
          megnevezése:
          <Box width="500px" textAlign="center">
            {employerName ? employerName : DOTTED_LINE}
          </Box>
          <Box>adószáma:</Box>
          <Box marginLeft="10px">
            {employerTaxNumber
              ? formatTaxNumber(employerTaxNumber)
              : DOTTED_LINE}
          </Box>
        </Box>
        <Box height="10px" />
        <Box>
          A nyilatkozat tartalmát tudomásul vettem. A magánszemély adóelőlegét
          az I. Blokkban szereplő nyilatkozat figyelembevételével állapítom meg.
        </Box>
        <Box height="20px" />
        <CorporateSignature orientation="vertical" />
      </Box>
    </ThemeProvider>
  );
};

export default MyTaxCreditApplicationPrintEmployer;
